var map = {
	"./cake.webp": 1771,
	"./crown-blue.webp": 1772,
	"./crown.webp": 1773,
	"./pocket.webp": 1774,
	"./present.webp": 1775,
	"./relegation.webp": 1776,
	"./t-deposit.webp": 1777,
	"./t-turnover.webp": 1778,
	"./vip-bg.webp": 1779,
	"./vip1.gif": 1780,
	"./vip1.webp": 1781,
	"./vip10-bg.webp": 1782,
	"./vip10.gif": 1783,
	"./vip10.webp": 1784,
	"./vip11-bg.webp": 1785,
	"./vip11.gif": 1786,
	"./vip11.webp": 1787,
	"./vip12-bg.webp": 1788,
	"./vip12.gif": 1789,
	"./vip12.webp": 1790,
	"./vip2.gif": 1791,
	"./vip2.webp": 1792,
	"./vip3.gif": 1793,
	"./vip3.webp": 1794,
	"./vip4.gif": 1795,
	"./vip4.webp": 1796,
	"./vip5.gif": 1797,
	"./vip5.webp": 1798,
	"./vip6.gif": 1799,
	"./vip6.webp": 1800,
	"./vip7.gif": 1801,
	"./vip7.webp": 1802,
	"./vip8.gif": 1803,
	"./vip8.webp": 1804,
	"./vip9.gif": 1805,
	"./vip9.webp": 1806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;